import { useEffect, useState } from "react";
import "./discussion-container.css";
import { BsSearch } from "react-icons/bs";
import DiscussionItem from "../discussion-item/DiscussionItem";
import DiscussionBox from "../../../../ui/molecules/discussion-box/DiscussionBox";
import { useSelector, useDispatch } from "react-redux";
import { onGetDiscussions } from "../../../admin/services/user";
import { isEmpty } from "../../../../core/utils/helpers";
import { configurationSlice } from "../../../../app/store/slices/configurationSlice";
import moment from "moment";
import { socketIo } from "../../../../core/socket/socket-client";
import useAxiosPrivate from "../../../../app/providers/context-provider/useAxiosPrivate";

const DiscussionContainer = () => {
  const dispatch = useDispatch();
  const axiosPrivate = useAxiosPrivate()

  const [isRefresh, setIsRefresh] = useState(false);
  const [discussionsData, setDiscussionsData] = useState([]);

  const currentConnectedStream = useSelector(
    (state) => state.setInitConf.currentConnectedStream,
  );

  const _inscription_id = currentConnectedStream?.inscription_id;

  useEffect(() => {
    onRefreshDiscussions();
  }, [isRefresh]);

  useEffect(() => {
    socketIo.emit("authenticate", { inscription_id: _inscription_id });

    const onHandleNewMessage = (data) => {
      if (data?.status) onRefreshDiscussions();
    };

    socketIo.on("on_new_message", onHandleNewMessage);

    return () => {
      socketIo.off("on_new_message", onHandleNewMessage);
    };
  }, []);

  const onRefreshDiscussions = () => {
    const localData = {
      inscription_id: _inscription_id,
      dates: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    };
    onGetDiscussions(axiosPrivate, localData).then((response) => {
      const _data = response?.data?.result;
      setDiscussionsData(_data);
      setIsRefresh((prevState) => !prevState);
    });
  };

  return (
    <div className="discussion-container">
      <div className="dis-cont-chat-items">
        <div className="dis-cont-chat-items-head">
          <BsSearch className="icon" />
          <input type="text" placeholder="Search" />
        </div>
        <div className="dis-cont-chat-items-body">
          {isEmpty(discussionsData) ? (
            <p
              style={{
                fontStyle: "italic",
                color: "grey",
                fontSize: "1rem",
                textAlign: "center",
              }}
            >
              No chat available yet..!
            </p>
          ) : (
            discussionsData?.map((discussion) => {
              return (
                <DiscussionItem
                  key={discussion?.conversation_id}
                  data={discussion}
                  onAction={() => {
                    dispatch(
                      configurationSlice.actions.setCurrentConversation({
                        participant_id: discussion?.participant_id,
                        participant_name: `${discussion?.firstname} ${discussion?.lastname}`,
                        type: discussion?.conversation_mode,
                        connexion_status: discussion?.connexion_status,
                      }),
                    );
                  }}
                />
              );
            })
          )}
        </div>
      </div>
      <div className="dis-cont-chat-box">
        <DiscussionBox />
      </div>
    </div>
  );
};

export default DiscussionContainer;
